<template>
  <main>
    <wl-banner bgUrl='/static/img/product/zhsys/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc' :isNeedDesc="false"></wl-title>
      </article>
    </section>

    <!-- <section class="page2 bg" v-lazy:background-image="'/static/img/product/zhsys/bg2.png'">
      <article class="container">
        <section class="center">
          <h2>数据中台</h2>
          <p>打通以往的数据孤岛沉淀数据资产，实现价值共通</p>
        </section>
        <section class="box1">
          <h3>{{data[0].title}}</h3>
          <p>{{data[0].desc}}</p>
        </section>
        <section class="box2">
          <h3>{{data[1].title}}</h3>
          <p>{{data[1].desc}}</p>
          <p class="pl-10">智慧的实验室</p>
        </section>
        <section class="box3">
          <h3>{{data[2].title}}</h3>
          <p>{{data[2].desc}}</p>
        </section>
      </article>
    </section> -->
    <section class="page3">
      <article class="container flex">
        <wl-title :title='page3Data.title' :desc='page3Data.desc' :isNeedDesc="false"></wl-title>
      </article>
      <article class="page4Data">
        <section v-for="item in page4Data" class="page4Data-item">
          <img :src="item.img" class="page4Data-img" />
          <section class="page4Data-textBox">
            <h4 class="page4Data-title">{{ item.title }}</h4>
            <section class="page4Data-text">{{ item.desc }}</section>
          </section>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>


<script>
export default {
  name: 'zhsysManagePlatform',
  data() {
    return {
      bannerData: {
        title: '智慧实验室管理平台',
        desc: '深度融合AI算法大模型、物联网技术、数字孪生、大数据分析等\n提供“看得清风险、管得住流程、防得住事故”的全场景解决方案'
      },
      page1Data: {
        title: 'AI加速实验室管理智能化',
        desc: ''
      },
      page3Data: {
        title: '核心技术',
        desc: ''
      },
      page4Data: [
        {
          img: '/static/img/product/zhsys/p1.png',
          title: '人工智能技术',
          desc: '人脸识别、图像识别、目标检测等A1技术，自研视频流处理技术，能接入数百台摄像头，自研多种实验室安全AI监测分析模型'
        },
        {
          img: '/static/img/product/zhsys/p2.png',
          title: '物联网技术',
          desc: '自主研发的物联网平台，可接入数千个物联网设备,涵盖多种物联网设备，视频监控、智能门禁、电子班牌、环境监测等;支持远程控制'
        },
        {
          img: '/static/img/product/zhsys/p3.png',
          title: '实验室可视化',
          desc: '数字孪生，VR展示，GIS平台等多种呈现。映射实验室全业务周期过程，数据实时融合，清晰展示智慧决策'
        }
      ],
      data: [
        { title: '多业务系统联动', desc: '· 安全考试准入系统\n· 危化品管理系统\n· 仪器预约共享系统\n· 智能环境监测系统\n· 安全检查管理系统等' },
        { title: '智能硬件，物联应用', desc: '· 物联网智能硬件\n· 灵活搭载业务系统\n· 共同打造安全、便捷、' },
        { title: '3D全景可视化展示', desc: '· 迅速定位楼宇、实验室房间等目标信息  \n· 360°全空间记录、展示、监控实验室\n· 各业务数据一览无余，可视化展示' },
      ]
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
main {
  background: #fbfbff;
}

h3 {
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  line-height: 24px;
  padding-bottom: 32px;
}

p {
  font-size: 20px;
  color: #8e8e8e;
  line-height: 32px;
  white-space: pre-line;
  text-align: left;
}

.pl-10 {
  padding-left: 10px;
}

.page1 {
  height: 2500px;
  padding-top: 136px;
  background: url("/static/img/product/zhsys/bg1.png") center/cover;
  width: 100%;

  ::v-deep strong {
    color: #8e8e8e;
    padding-top: 54px;
    line-height: 34px;
    text-align: left;
  }
}

.flex section {
  text-align: center;
  width: 100%;
}

.page2 {
  height: 1029px;

  .container {
    position: relative;
    height: 100%;

    .center {
      width: 220px;
      position: absolute;
      left: 520px;
      top: 245px;

      h2 {
        font-size: 36px;
        line-height: 36px;
        font-weight: 500;
        color: #308DFF;
        padding-bottom: 24px;
      }

      p {
        line-height: 30px;
      }
    }

    .box1 {
      width: 196px;
      position: absolute;
      left: 35px;
      top: 227px;
    }

    .box2 {
      width: 216px;
      position: absolute;
      left: 1020px;
      top: 227px;
    }

    .box3 {
      width: 365px;
      position: absolute;
      left: 447px;
      top: 714px;

      h3 {
        text-align: left;
        padding-left: 131px;
      }
    }
  }
}

.page3 {
  margin-top: 50px;
}

.page4Data {
  width: 1400px;
  margin: 0 auto;
  display: flex;
}

.page4Data-item {
  width: 31%;
  border-radius: 20px;
  overflow: hidden;
  flex: 1;
  margin: 5% 2%;
  height: 520px;
  background-color: white;
  color: #262626;

  &:hover {
    cursor: pointer;
    background-color: #F66A27;
    color: #fff !important;
  }

  .page4Data-img {
    width: 100%;
  }

  .page4Data-textBox {
    width: 100%;
    padding: 0 7%;
    box-sizing: border-box;


    .page4Data-title {
      font-size: 26px;
      font-weight: 600;
      margin: 14px 0;
    }

    .page4Data-text {
      font-size: 20px;
      text-align: left;
      line-height: 34px;
    }
  }

}
</style>
